import React, { useEffect, useState } from "react";
import Cookies from "universal-cookie";
import Host from "../../assets/js/Host";
import axios from "../../assets/js/AxiosInterceptors";
import Lottie from "lottie-react-web";
import { toast } from "react-toastify";
import { Box, Button } from "@mui/material";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import CustomeSelectField from "../../Components/CustomeSelectField";
import PopupForm from "../../Components/PopupForm";
import CustomTextField from "../../Components/CustomTextField";
import feHost from "../../assets/js/feHost";
import DetailsV2 from "./DetailsV2";

const cookies = new Cookies();
const RenderContent = (props) => {
  const [t] = useTranslation("common");
  const maintheme = useSelector((state) => state.themeData.maintheme);
  const [showActivities,setShowActivities]=useState(false)
  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        minHeight: "100px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "10px",
        paddingTop: "20px",
        "& button": {
          borderRadius: "29px",
          padding: " 11px 20px",
        },
      }}
    >
    {showActivities?<DetailsV2 {...props} showActivities={showActivities} setShowActivities={setShowActivities}/>:null}

      {JSON.parse(localStorage.getItem("roles")).includes(9) ? (
        <Button
          variant="contained"
          color="success"
          onClick={() => {
            window.open(
              feHost + `LogTable?id=${props?.id}&name=${"Task"}`,
              "_blank"
            );
          }}
        >
          show Log Grid
        </Button>
      ) : null}
      <Button variant="contained" color="primary"
       onClick={()=>{
        setShowActivities(true)
       }}
      >
        show Activites
      </Button>
    </Box>
  );
};

const RenderFooter = (props) => {
  const gridtheme = useSelector((state) => state.themeData.gridtheme);
  const [t] = useTranslation("common");

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "end",
          alignItems: "center",
          width: "100%",
        }}
      >
        <Box display="flex">
          <Button
            variant="outlined"
            // spacing={2}
            sx={{
              width: "50% !important",
              // flexGrow: 1,
              minWidth: "80px !important",
              maxWidth: "80px !important",
              margin: 1,
              backgroundColor: "#f7f7f7",
              borderColor: gridtheme?.colorWhite,
              color: gridtheme?.colorblack,
              boxShadow: "0 0 7px -2px white",
              //   color:SearchButtonTheme?.clear_button_text_color,
              "&:hover": {
                backgroundColor: "#f7f7f7",
                borderColor: gridtheme?.colorWhite,
                color: gridtheme?.colorblack,
                boxShadow: "0 0 7px 1px white",
                boxShadow: "0",
              },
              height: "35px",
              fontFamily: "Cairo-Bold",
            }}
            className="iconeFilterClear"
            color="secondary"
            onClick={() => {
              props.setOpen(false);
            }}
          >
            {"Close"}
          </Button>
        </Box>
      </Box>
    </Box>
  );
};
const LogForm = (props) => {
  return (
    <PopupForm
      open={props.addForm}
      setOpen={props.setAddForm}
      width="30%"
      minHeight="200px"
      title={"Log Form"}
      content={<RenderContent {...props} />}
      footer={<RenderFooter open={props.addForm} setOpen={props.setAddForm} />}
    />
  );
};
export default LogForm;
